import { QUALITY_METRICS } from './qualityBreakdown';
import type { QualityBreakdown } from './qualityBreakdown';

export function getQualityMetricDetails(
    breakdown: QualityBreakdown,
    key: keyof QualityBreakdown,
    averageBreakdown?: QualityBreakdown,
) {
    const { total, per100Cells } = breakdown[key];
    const per100CellsSum = QUALITY_METRICS
        .filter(metric => metric.key !== 'affectedRecords')
        .reduce((sum, metric) => sum + (breakdown[metric.key].per100Cells ?? 0), 0);
    const contribution = key === 'affectedRecords' || per100Cells === undefined || per100CellsSum === 0
        ? undefined
        : (per100Cells / per100CellsSum) * 100;
    const averagePer100Cells = averageBreakdown?.[key].per100Cells;
    const vsAverage = per100Cells === undefined || averagePer100Cells === undefined || averagePer100Cells === 0
        ? undefined
        : ((per100Cells - averagePer100Cells) / averagePer100Cells) * 100;

    return {
        total,
        per100: per100Cells === undefined ? '—' : `${per100Cells.toFixed(2)}%`,
        contribution: contribution === undefined ? '—' : `${contribution.toFixed(2)}%`,
        vsAverage: vsAverage === undefined ? '—' : `${vsAverage > 0 ? '+' : ''}${vsAverage.toFixed(2)}%`,
        // More mistakes than the average is bad; fewer is good.
        vsAverageClass: vsAverage === undefined || vsAverage === 0
            ? undefined
            : vsAverage > 0 ? 'redText' : 'greenText',
    };
}
